import { toValue } from 'vue'
import { defineStore } from 'pinia'
import { set as _set } from 'lodash'
import ProcedureExecution from '@/classes/procedure_executions/ProcedureExecution'

export const useProcedureExecutionStore = defineStore('ProcedureExecutionStore', {
  state: () => ({
    procedure_execution: {},
    loader: false,
    error: {}
  }),
  getters: {
    getProcedureExecution: state => ({ procedure_id, execution_id, dependencies = [] }) => state.$getItem({
      key: procedure_id,
      resource: 'procedure_execution',
      dependencies: [procedure_id, ...dependencies],
      fetch: () => state.fetchProcedureExecution({ procedure_id, execution_id })
    })
  },
  actions: {
    async fetchProcedureExecution ({ procedure_id, execution_id }) {
      const args = await this.$pipeline({
        default_value: new ProcedureExecution(),
        resource: `procedure_execution.${toValue(procedure_id)}`,
        dependencies: [procedure_id, execution_id]
      })

      return this.$fetchItem({
        ...args,
        endpoint: `/api/v1/procedures/${toValue(procedure_id)}/executions/${toValue(execution_id)}`,
        model: ProcedureExecution
      })
    },
    async postProcedureExecution ({ procedure_id, params }) {
      await this.$pipeline({ dependencies: [procedure_id] })

      return this.$postItem({
        endpoint: `/api/v1/procedures/${toValue(procedure_id)}/execute`,
        resource: `procedure_execution.${toValue(procedure_id)}`,
        model: ProcedureExecution,
        params
      })
    },
    async patchProcedureExecutionInformations ({ procedure_id, execution_id, params }) {
      await this.$pipeline({ dependencies: [procedure_id, execution_id] })

      return this.$patchItem({
        endpoint: `/api/v1/procedures/${toValue(procedure_id)}/executions/${toValue(execution_id)}`,
        resource: `procedure_execution.${toValue(procedure_id)}`,
        model: ProcedureExecution,
        params: {
          procedure_execution: { informations: params }
        }
      })
    },
    async patchPublicProcedureExecutionInformations ({ procedure_id, execution_id, params }) {
      await this.$pipeline({ dependencies: [procedure_id, execution_id] })

      return this.$patchItem({
        endpoint: `/api/v1/procedures/${toValue(procedure_id)}/executions/${toValue(execution_id)}`,
        model: ProcedureExecution,
        params: {
          procedure_execution: { informations: params }
        }
      })
    }
  },
  persist: {
    pick: ['procedure_execution'],
    storage: sessionStorage,
    afterHydrate: ({ store }) => {
      const state = store.$state.procedure_execution
      Object.keys(state).forEach(key => _set(state, key, { item: new ProcedureExecution(state[key].item), loader: false, error: state[key].error, status: state[key].status }))
    }
  }
})
